module.exports = __webpack_public_path__ + "fonts/icomoon.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/icomoon.eot
// module id = ./node_modules/@ps/common-core/dist/fonts/icomoon.eot
// module chunks = 1